module.exports = __webpack_public_path__ + "static/media/sort-down-button.7b18ecb4.svg";